import {usePage} from '@inertiajs/react'
import {bigFrameDaysActive} from '@/Util/BigFrameDays'
import {usePromotionTime} from '@/Hooks/usePromotionTime'
import './BigFrameDaysBanner.css'

export default function BigFrameDaysBanner({className = ''}) {
    const {settings} = usePage().props
    const promotion = settings?.promotions?.bigFrameDays
    const now = usePromotionTime(promotion)
    if (!bigFrameDaysActive(promotion, now)) return null

    return (
        <a href={promotion.href} className={`big-frame-days-banner ${className}`.trim()}
           style={{'--big-frame-days-background': promotion.background_color, '--big-frame-days-text': promotion.text_color}}>
            <span className="big-frame-days-banner__copy">
                {promotion.title}: <strong>{promotion.headline}</strong>, {promotion.date_label}.
            </span>
            <span className="big-frame-days-banner__cta">Shop Now <span aria-hidden="true">→</span></span>
        </a>
    )
}
